import { RefObject, useState, useEffect, useRef } from "react";

type ScrollPosition = "TOP" | "MIDWAY" | "BOTTOM";

export function useScrollPosition<T extends HTMLDivElement>(): [
  RefObject<T>,
  ScrollPosition
] {
  const [scrollPosition, setScrollPosition] = useState<ScrollPosition>("TOP");

  const ref = useRef<T>(null);

  useEffect(() => {
    const element = ref.current;

    if (element) {
      element.addEventListener("scroll", checkScroll);
    }

    return () => {
      window.removeEventListener("scroll", checkScroll);
    };
  });

  const checkScroll = (e: Event) => {
    const targetNode = e.target as HTMLElement;
    if (targetNode.scrollTop === 0) {
      if (scrollPosition !== "TOP") {
        setScrollPosition("TOP");
      }
      return;
    }

    if (targetNode.scrollTop > 0) {
      if (
        targetNode.scrollTop <
        targetNode.scrollHeight - targetNode.offsetHeight
      ) {
        if (scrollPosition !== "MIDWAY") {
          setScrollPosition("MIDWAY");
        }
        return;
      }
      if (scrollPosition !== "BOTTOM") {
        setScrollPosition("BOTTOM");
      }
    }
    return;
  };

  return [ref, scrollPosition];
}
